import { NgModule } from '@angular/core';

/** Shipped builds do not include the dev mock backend. */
@NgModule({})
export class MockBackendModule {}
